export default __webpack_public_path__ + "static/media/doctor-6.d54b8394.jpg";